import { styled } from 'baseui'

export const Container = styled('div', ({ $theme }) => ({
    position: 'relative',
    marginTop: '2rem',
    padding: '0 1.6rem'
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 700,
    color: '#000',
    marginTop: 0,
    marginBottom: '0.8rem'
}))

export const Description = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 300,
    marginTop: 0,
    marginBottom: '0.8rem'
}))

export const ViewContainer = styled('div', ({ $theme }) => ({
    marginTop: '2rem'
}))

export const LotsSectionWrapper = styled('div', ({ $theme }) => ({}))

export const ToggleIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.white,
    fontSize: '1.6rem'
}))

export const ToggleText = styled('span', ({ $theme }) => ({
    color: $theme.colors.white,
    ...$theme.typography.LabelSmall,
    fontWeight: 700
}))
